import type { ComparisonConfig } from './ComparisonPage';


const INNROAD_JA: ComparisonConfig = {
  slug: 'hotelstack-vs-innroad',
  competitorName: 'innRoad',
  heroTitle: 'HotelStack.io vs innRoad',
  heroSubtitle: 'innRoadは基本的な機能セットを持つ独立系ホテル向けの米国ベースのクラウドPMSです。HotelStack.ioは高度なレベニューマネジメント、F&B/POS、マルチプロパティサポート、グローバルコンプライアンスを含む36モジュールを同等価格帯で提供します。',
  overviewComparison: [
    { label: 'モジュール総数', hotelstack: '36の統合モジュール', competitor: '8以上のコア機能' },
    { label: '料金', hotelstack: '月額$49から', competitor: '月額$100以上' },
    { label: 'マルチプロパティ', hotelstack: 'フルチェーン管理', competitor: '非対応' },
    { label: 'F&B / POS', hotelstack: '内蔵', competitor: '利用不可' },
    { label: 'グローバル展開', hotelstack: '40か国以上', competitor: '米国中心' },
    { label: 'レベニューマネジメント', hotelstack: '高度（内蔵）', competitor: '基本レートツール' },
  ],
  featureTable: [
    {
      category: '基幹PMS',
      features: [
        { name: 'クラウドベースPMS', hotelstack: true, competitor: true },
        { name: 'ビジュアルルームボード', hotelstack: true, competitor: true },
        { name: '予約管理', hotelstack: true, competitor: true },
        { name: 'ナイトオーディットウィザード', hotelstack: true, competitor: true },
        { name: 'ゲストフォリオ管理', hotelstack: true, competitor: true },
        { name: 'オンラインチェックインポータル', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '流通・予約',
      features: [
        { name: 'チャネルマネージャー（100以上のOTA）', hotelstack: true, competitor: '限定OTA' },
        { name: 'GDS接続', hotelstack: true, competitor: true },
        { name: '手数料無料予約エンジン', hotelstack: true, competitor: true },
        { name: 'グループ予約', hotelstack: true, competitor: '基本' },
        { name: '法人料金管理', hotelstack: true, competitor: '制限あり' },
      ],
    },
    {
      category: 'レベニューマネジメント',
      features: [
        { name: 'ダイナミックプライシングルール', hotelstack: true, competitor: '基本' },
        { name: 'What-If収益シミュレーター', hotelstack: true, competitor: false },
        { name: '競合料金モニター', hotelstack: true, competitor: false },
        { name: '需要予測', hotelstack: true, competitor: false },
        { name: 'RevPAR分析', hotelstack: true, competitor: '基本' },
      ],
    },
    {
      category: 'オペレーション・F&B',
      features: [
        { name: 'POSターミナル', hotelstack: true, competitor: false },
        { name: 'ルームサービスモジュール', hotelstack: true, competitor: false },
        { name: 'ハウスキーピング管理', hotelstack: true, competitor: '基本' },
        { name: 'メンテナンス作業指示', hotelstack: true, competitor: false },
        { name: 'スタッフスケジューリング', hotelstack: true, competitor: false },
        { name: 'キッチンディスプレイシステム', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'レポート・コンプライアンス',
      features: [
        { name: 'フラッシュレポート', hotelstack: true, competitor: true },
        { name: '損益計算書', hotelstack: true, competitor: false },
        { name: 'ペースレポート', hotelstack: true, competitor: false },
        { name: '多通貨請求', hotelstack: true, competitor: false },
        { name: '地域税コンプライアンス', hotelstack: true, competitor: '米国のみ' },
        { name: 'カスタムレポートビルダー', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'レジリエンスとオフライン',
      features: [
        { name: 'オフライン対応PWA', hotelstack: true, competitor: false },
        { name: 'オフライン更新キュー', hotelstack: true, competitor: false },
        { name: '再接続時のバックグラウンド同期', hotelstack: true, competitor: false },
        { name: '競合を検知する照合', hotelstack: true, competitor: false },
        { name: 'インストール可能なフロントデスク', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '法人・団体セールス',
      features: [
        { name: '法人料金管理', hotelstack: true, competitor: '制限あり' },
        { name: 'ルーミングリスト付き団体予約', hotelstack: true, competitor: '基本' },
        { name: '売掛金年齢分析・実績レポート', hotelstack: true, competitor: false },
        { name: 'レストラン予約', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'スタッフ・人事',
      features: [
        { name: 'スタッフ名簿・シフト管理', hotelstack: true, competitor: false },
        { name: '給与計算', hotelstack: true, competitor: false },
        { name: '休暇・勤怠管理', hotelstack: true, competitor: false },
        { name: 'パフォーマンス分析', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$100+',
    hotelstackNote: '36モジュールすべて含む。グローバル多通貨対応。EUR、GBP、AED、INR、THBでの地域別料金設定。無料オンボーディングと移行。',
    competitorNote: '月額$100以上の見積もりベース料金。米国中心で国際機能は制限あり。F&B、マルチプロパティ、高度な分析のない基本機能セット。',
  },
  advantages: [
    '4倍のモジュール（36対8以上）を約半額の開始価格で提供',
    'フルマルチプロパティチェーン管理 — innRoadは単一施設のみサポート',
    'POS、ルームサービス、キッチンディスプレイ、メニュー管理を含む完全なF&Bモジュール',
    'ダイナミックプライシング、予測、シミュレーターを備えた高度なレベニューマネジメント',
    'innRoadの米国のみフォーカスに対して40か国以上のグローバルリーチ',
    '国際施設向けの多通貨請求と地域税コンプライアンス',
    'ロイヤルティプログラム、ゲストCRM、自動コミュニケーションを含む',
    '24時間365日専任サポート付きの無料オンボーディングとデータ移行',
  ],
  verdict: {
    title: '総合評価',
    summary: 'innRoadは基本的な予約とフロントデスク管理を必要とする米国ベースの独立系ホテル向けのシンプルなクラウドPMSです。HotelStack.ioは4倍のモジュール、マルチプロパティサポート、F&B/POS、高度な収益ツール、グローバルリーチを備えた、はるかに包括的なプラットフォームを低価格で提供します。基本的なPMSニーズを超えた成長を計画しているホテルにとって、HotelStack.ioが明確な選択肢です。',
    bestFor: [
      '基本PMSから完全なプラットフォームへのアップグレードを求める独立系ホテル',
      'innRoadにないF&B、POS、オペレーションツールが必要な施設',
      '多通貨とコンプライアンスツールが必要な国際展開を行うホテル',
      '将来の成長に向けたマルチプロパティ管理を求める施設',
      '基本的なレート設定を超えた高度なレベニューマネジメントを求めるホテル',
    ],
  },
  faqItems: [
    { question: 'innRoadからHotelStack.ioに移行できますか？', answer: '当社の移行チームがゲストプロファイル、予約履歴、料金プラン、客室設定を含むinnRoadからの完全なデータ移行を担当します。移行は無料で、通常48時間以内にダウンタイムゼロで完了します。' },
    { question: 'innRoadのような米国の独立系ホテルにHotelStack.ioは対応していますか？', answer: 'もちろんです。HotelStack.ioは米国および40か国以上の独立系ホテルをサポートしています。米国のホテルはF&B/POS、レベニューマネジメント、マルチプロパティサポートなど、innRoadにない機能を含む全36モジュールを月額$49から利用できます。' },
    { question: 'GDS接続においてHotelStack.ioとinnRoadはどう比較されますか？', answer: '両プラットフォームともAmadeusとSabre経由のGDS接続を提供しています。HotelStack.ioはさらにグローバルに100以上のOTAへの接続、メタサーチ統合、手数料無料予約エンジン（BookMyRoom.io）を基本価格に含みます。' },
    { question: 'innRoadと違い、HotelStack.ioは複数施設を管理できますか？', answer: 'はい。HotelStack.ioには一元ダッシュボード、クロスプロパティ分析、共有レート配信、ブランド基準管理、統合レポートを備えたフルチェーン管理が含まれています。innRoadは単一施設運営向けに設計されています。' },
  ],
};

const WEBREZPRO_JA: ComparisonConfig = {
  slug: 'hotelstack-vs-webrezpro',
  competitorName: 'WebRezPro',
  heroTitle: 'HotelStack.io vs WebRezPro',
  heroSubtitle: 'WebRezProは会計重視で中小規模ホテルをターゲットにしたカナダのクラウドPMSです。HotelStack.ioは36モジュール、エンタープライズグレードUI、高度な収益ツール、フルF&B/POSを備えた、次世代ホスピタリティ向けのモダンで機能豊富なプラットフォームを提供します。',
  overviewComparison: [
    { label: 'モジュール総数', hotelstack: '36の統合モジュール', competitor: '10以上のコア機能' },
    { label: '料金', hotelstack: '月額$49から', competitor: '月額$75以上' },
    { label: 'UI/UX品質', hotelstack: 'モダンダークラグジュアリー', competitor: '機能的/旧式' },
    { label: 'F&B / POS', hotelstack: '内蔵', competitor: '利用不可' },
    { label: 'レベニューマネジメント', hotelstack: '高度（内蔵）', competitor: '基本レートツール' },
    { label: 'マルチプロパティ', hotelstack: 'フルチェーン管理', competitor: '制限あり' },
  ],
  featureTable: [
    {
      category: '基幹PMS',
      features: [
        { name: 'クラウドベースPMS', hotelstack: true, competitor: true },
        { name: 'ビジュアルルームボード', hotelstack: true, competitor: true },
        { name: '予約管理', hotelstack: true, competitor: true },
        { name: 'ナイトオーディットウィザード', hotelstack: true, competitor: true },
        { name: 'ゲストフォリオ管理', hotelstack: true, competitor: true },
        { name: 'オンラインチェックインポータル', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '会計・財務',
      features: [
        { name: '統合会計', hotelstack: true, competitor: true },
        { name: '損益計算書', hotelstack: true, competitor: true },
        { name: '売掛金管理', hotelstack: true, competitor: true },
        { name: '多通貨請求', hotelstack: true, competitor: '制限あり' },
        { name: '地域税コンプライアンス', hotelstack: true, competitor: 'CAD/USD中心' },
        { name: 'カスタム請求書テンプレート', hotelstack: true, competitor: true },
      ],
    },
    {
      category: '収益・流通',
      features: [
        { name: 'チャネルマネージャー（100以上のOTA）', hotelstack: true, competitor: 'OTA数限定' },
        { name: 'ダイナミックプライシングルール', hotelstack: true, competitor: '基本' },
        { name: 'What-If収益シミュレーター', hotelstack: true, competitor: false },
        { name: '競合料金モニター', hotelstack: true, competitor: false },
        { name: '需要予測', hotelstack: true, competitor: false },
        { name: '手数料無料予約エンジン', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'F&B・オペレーション',
      features: [
        { name: 'POSターミナル', hotelstack: true, competitor: false },
        { name: 'ルームサービスモジュール', hotelstack: true, competitor: false },
        { name: 'キッチンディスプレイシステム', hotelstack: true, competitor: false },
        { name: 'ハウスキーピング管理', hotelstack: true, competitor: true },
        { name: 'メンテナンス作業指示', hotelstack: true, competitor: false },
        { name: 'スタッフスケジューリング', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'ゲスト・エンタープライズ',
      features: [
        { name: '360度ゲストプロファイル', hotelstack: true, competitor: '基本' },
        { name: 'ロイヤルティプログラム管理', hotelstack: true, competitor: false },
        { name: 'ゲストコミュニケーション自動化', hotelstack: true, competitor: '制限あり' },
        { name: 'チェーンダッシュボード', hotelstack: true, competitor: '制限あり' },
        { name: 'クロスプロパティ分析', hotelstack: true, competitor: false },
        { name: 'ブランド基準管理', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'レジリエンスとオフライン',
      features: [
        { name: 'オフライン対応PWA', hotelstack: true, competitor: false },
        { name: 'オフライン更新キュー', hotelstack: true, competitor: false },
        { name: '再接続時のバックグラウンド同期', hotelstack: true, competitor: false },
        { name: '競合を検知する照合', hotelstack: true, competitor: false },
        { name: 'インストール可能なフロントデスク', hotelstack: true, competitor: false },
      ],
    },
    {
      category: '法人・団体セールス',
      features: [
        { name: '法人料金管理', hotelstack: true, competitor: false },
        { name: 'ルーミングリスト付き団体予約', hotelstack: true, competitor: false },
        { name: '売掛金年齢分析・実績レポート', hotelstack: true, competitor: false },
        { name: 'レストラン予約', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'スタッフ・人事',
      features: [
        { name: 'スタッフ名簿・シフト管理', hotelstack: true, competitor: false },
        { name: '給与計算', hotelstack: true, competitor: false },
        { name: '休暇・勤怠管理', hotelstack: true, competitor: false },
        { name: 'パフォーマンス分析', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$75+',
    hotelstackNote: '36モジュールすべて含む。モダンエンタープライズグレードUI。EUR、GBP、AED、INR、THBでの地域別料金設定。無料オンボーディングと移行。',
    competitorNote: '月額$75以上（CAD）の室数ベース料金。機能的だが旧式のインターフェース。F&B、マルチプロパティ、北米サポートに制限あり。',
  },
  advantages: [
    'モダンエンタープライズグレードインターフェースで3倍以上のモジュール（36対10以上）',
    'POS、ルームサービス、キッチン管理を含む完全なF&Bモジュール',
    'ダイナミックプライシング、予測、What-Ifシミュレーターを備えた高度なレベニューマネジメント',
    'WebRezProの機能的だが旧式のインターフェースに対して2026年向けに設計されたモダンダークラグジュアリーUI',
    '一元分析とレート配信を備えたフルマルチプロパティチェーン管理',
    'WebRezProの北米フォーカスに対して40か国以上のグローバルリーチ',
    'リピート予約のためのロイヤルティプログラム、ゲストCRM、自動コミュニケーション',
    '24時間365日専任サポート付きの無料オンボーディングとデータ移行',
  ],
  verdict: {
    title: '総合評価',
    summary: 'WebRezProは北米の中小規模ホテル向けの強力な会計機能を持つ信頼性の高いカナダのPMSです。しかし、旧式のUI、限定的な機能セット、F&B、高度な収益ツール、エンタープライズスケーラビリティの欠如により、2026年では競争力が低くなっています。HotelStack.ioは会計面でWebRezProに匹敵しながら、22以上の追加モジュール、ワールドクラスのインターフェース、グローバル機能を備えたモダンで包括的なプラットフォームを提供します。',
    bestFor: [
      '会計の深さを犠牲にせずモダンUIへのアップグレードを求めるホテル',
      '基本PMSを超えたF&B、POS、キッチン管理が必要な施設',
      '高度なレベニューマネジメントとダイナミックプライシングツールを求めるホテル',
      '北米を超えて国際展開する施設',
      'フルマルチプロパティチェーン管理が必要な成長するホテルグループ',
    ],
  },
  faqItems: [
    { question: 'WebRezProからHotelStack.ioに移行できますか？', answer: '当社の移行チームがゲストプロファイル、予約履歴、料金プラン、会計データ、客室設定を含むWebRezProからの完全なデータ移行を担当します。移行は無料で、通常48時間以内にダウンタイムゼロで完了します。' },
    { question: 'HotelStack.ioはWebRezProの会計機能に匹敵しますか？', answer: 'はい。HotelStack.ioには統合会計、損益計算書、売掛金管理、カスタム請求書、多通貨請求が含まれています。さらに、WebRezProにないF&B、レベニューマネジメント、ゲストCRM、マルチプロパティ管理を含む22以上の追加モジュールが含まれています。' },
    { question: 'WebRezProとHotelStack.ioのUI比較は？', answer: 'HotelStack.ioは最新のWeb技術で構築されたモダンダークラグジュアリーインターフェースを備え、すべてのデバイスでレスポンシブデザインを提供します。WebRezProは前世代のWebアプリケーション向けに設計された機能的だが旧式のインターフェースです。' },
    { question: '現在WebRezProを使用しているカナダの施設にHotelStack.ioは適していますか？', answer: 'もちろんです。HotelStack.ioはCADを含む多通貨請求、カナダの税務コンプライアンス（GST/HST/PST）、主要な北米OTAへの接続をサポートしています。多くのカナダの施設が追加モジュールとモダンな体験のために乗り換えています。' },
  ],
};


export const COMPARISON_JA_P3B: Record<string, ComparisonConfig> = {
  'hotelstack-vs-innroad': INNROAD_JA,
  'hotelstack-vs-webrezpro': WEBREZPRO_JA,
};
